import type { LargeCategoryCode } from './type';
export const peopleLedgerDetailKey = {
  all: ['peopleLedgerDetail'] as const,
  detail: (personId: string, largeCategoryCode: LargeCategoryCode) => [...peopleLedgerDetailKey.all, personId, largeCategoryCode] as const
} as const;